import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RootComponent } from './root/root.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AppRoutingModule } from '../app-routing.module';
import { NavigationComponent } from './navigation/navigation.component';
import { BrowserAnimationsModule }  from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { MaterialModule } from '@funceme/material';
import { BannerModalComponent } from './components/banner-modal/banner-modal.component';

@NgModule({
  declarations: [
    RootComponent, 
    HeaderComponent, 
    FooterComponent, 
    NavigationComponent,
    BannerModalComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MaterialModule, 
    FormsModule
  ],
  entryComponents: [
    BannerModalComponent
  ]
})
export class LayoutModule { }
